import { GLOBALS } from './globals';

type themeTypes = 'yellow' | 'blue';

export interface themeProps {
  color: themeTypes;
}

export const theme: themeProps = {
  color: GLOBALS.theme as themeTypes,
};
